import { type Firestore, doc, getDoc } from 'firebase/firestore';

import { activeBranches, organisationSettingsSchema } from '../../core/organisation/schema';
import type { Branch } from '../../core/organisation/schema';
import type { OrganisationPort } from '../../features/auth/application/ports/organisationPort';

/**
 * Firestore implementation of `OrganisationPort` (blueprint §11.1).
 *
 * One document read. Validated against the canonical schema at the boundary
 * (§6.3) rather than trusted — a settings document is edited by hand more often
 * than most, and a malformed branch list should surface here rather than as a
 * blank dropdown the employee cannot get past.
 */
export function createFirebaseOrganisationAdapter(firestore: Firestore): OrganisationPort {
  return {
    async listActiveBranches(): Promise<readonly Branch[]> {
      const snapshot = await getDoc(doc(firestore, 'organisationSettings', 'current'));

      if (!snapshot.exists()) {
        // Not an error the employee can act on, but not silently empty either:
        // an empty list means nobody can register, and that needs to be loud.
        throw new Error('لم تُضبط إعدادات الفروع بعد. راجع الموارد البشرية.');
      }

      const parsed = organisationSettingsSchema.safeParse(snapshot.data());
      if (!parsed.success) {
        throw new Error('إعدادات الفروع غير صالحة. راجع الموارد البشرية.');
      }

      return activeBranches(parsed.data);
    },
  };
}
